import { render } from "./SalesContactCard.vue?vue&type=template&id=00a90c07&scoped=true"
import script from "./SalesContactCard.vue?vue&type=script&lang=js"
export * from "./SalesContactCard.vue?vue&type=script&lang=js"

import "./SalesContactCard.vue?vue&type=style&index=0&id=00a90c07&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a90c07"]])

export default __exports__